module.exports = __webpack_public_path__ + "static/half_ogre-02fadb41638ac266d5bb49c04ffc3044.jpeg";